export const TYPES_OF_DELIVERY = [
  {
    label: 'DELIVERY.LEVEL1',
    value: 'level1' as 'level1',
  },
  {
    label: 'DELIVERY.LEVEL2',
    value: 'level2' as 'level2',
  },
  {
    label: 'DELIVERY.LEVEL3',
    value: 'level3' as 'level3',
  },
  {
    label: 'DELIVERY.LEVEL4',
    value: 'level4' as 'level4',
  },
];
export type TypeOfDeliveryType = (typeof TYPES_OF_DELIVERY)[number]['value'];
export const TYPES_OF_DELIVERY_MAP = new Map<string, string>(
  TYPES_OF_DELIVERY.map((item) => [String(item.value), item.label]) as any
) as any;
